export const SERVICE_DESK_ROUTE_PREFIX = '/jira/servicedesk/projects/:projectKey';
export const SERVICE_DESK_ROUTE_PREFIX_WITHOUT_PROJECT = '/jira/servicedesk';
export const SERVICE_HASHED_ARI = '/:serviceAri';
export const SERVICES_ROUTE_SUFFIX = '/services';
export const SERVICE_MODAL_ROUTE_SUFFIX = '/service-modal';
